import { render, staticRenderFns } from "./RubricVersion.vue?vue&type=template&id=0771c66e&"
import script from "./RubricVersion.vue?vue&type=script&lang=js&"
export * from "./RubricVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports